/**
 * Haley Hybrid PDP
 * Gallery, variant picker, price updates, and layer-card state.
 */

(function () {
  'use strict';

  const container = document.querySelector('[data-hh-product]');
  if (!container) return;

  const galleryImage = container.querySelector('#hh-gallery-image');
  const thumbs = container.querySelectorAll('[data-hh-thumb]');

  thumbs.forEach((thumb) => {
    thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
    thumb.addEventListener('click', () => {
      if (!galleryImage) return;

      galleryImage.src = thumb.dataset.src;
      galleryImage.alt = thumb.dataset.alt || galleryImage.alt;

      thumbs.forEach((item) => {
        item.classList.toggle('is-active', item === thumb);
        item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
      });
    });
  });

  const layerButtons = container.querySelectorAll('[data-hh-layer]');
  layerButtons.forEach((button) => {
    button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
    button.addEventListener('click', () => {
      layerButtons.forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
    });
  });

  const variantsJson = document.getElementById('hh-product-json');
  if (!variantsJson) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (error) {
    console.error('Haley Hybrid: failed to parse variants', error);
    return;
  }

  const variantInputs = container.querySelectorAll('[data-hh-variant-input]');
  const currentPrices = container.querySelectorAll('[data-hh-price]');
  const comparePrice = container.querySelector('[data-hh-compare]');
  const discount = container.querySelector('[data-hh-discount]');
  const ctaText = container.querySelector('[data-hh-cta-text]');
  const ctaPrice = container.querySelector('[data-hh-cta-price]');
  const addButtons = container.querySelectorAll('[data-hh-add]');
  const sizeCards = container.querySelectorAll('[data-hh-size-card]');
  const mobileSelect = container.querySelector('[data-hh-mobile-size-select]');

  function money(cents, showCents) {
    const amount = showCents ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
    return 'HK$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function setHidden(el, shouldHide) {
    if (!el) return;
    el.hidden = shouldHide;
  }

  function updateVariant(variant) {
    if (!variant) return;

    variantInputs.forEach((input) => {
      input.value = variant.id;
    });

    currentPrices.forEach((price) => {
      price.textContent = money(variant.price, false);
    });

    // Nightly cost line under the price (snippets/haley-per-night.liquid)
    container.querySelectorAll('[data-haley-per-night]').forEach((el) => {
      const amount = el.querySelector('[data-per-night-amount]');
      const nights = Number(el.dataset.nights) || 0;
      if (amount && nights > 0) amount.textContent = 'HK$' + (Math.floor(variant.price / nights) / 100).toFixed(2);
    });
    if (ctaPrice) ctaPrice.textContent = variant.available ? money(variant.price, false) : '';

    const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (hasCompare) {
      if (comparePrice) comparePrice.textContent = money(variant.compare_at_price, false);
      if (discount) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discount.textContent = '-' + pct + '%';
      }
    }
    setHidden(comparePrice, !hasCompare);
    setHidden(discount, !hasCompare);

    sizeCards.forEach((card) => {
      const isActive = String(card.dataset.variantId) === String(variant.id);
      card.classList.toggle('is-active', isActive);
      const input = card.querySelector('input');
      if (input) input.checked = isActive;
    });

    if (mobileSelect) {
      mobileSelect.value = String(variant.id);
    }

    addButtons.forEach((button) => {
      button.disabled = !variant.available;
    });
    if (ctaText) ctaText.textContent = variant.available ? (ctaText.dataset.textAvailable || '加入購物車') : '暫時售罄';

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    container.dispatchEvent(new CustomEvent('haley:variant-change', { bubbles: true, detail: variant }));
  }

  sizeCards.forEach((card) => {
    card.addEventListener('click', () => {
      if (card.dataset.available === 'false') return;
      const variant = variants.find((item) => String(item.id) === String(card.dataset.variantId));
      updateVariant(variant);
    });
  });

  if (mobileSelect) {
    mobileSelect.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(mobileSelect.value));
      updateVariant(variant);
    });
  }

  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant');
  if (variantId) {
    const variant = variants.find((item) => String(item.id) === String(variantId));
    updateVariant(variant);
  }
})();
